import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const MilestoneService = {

  getAllMilestone: async () => {
    try {
      const response = await axios.get(ENDPOINT.Milestone);
      return response.data;
    } catch (error) {
      console.error("Error fetching Milestone:", error.message);
      throw error;
    }
  },

  getAllByProject: async (pro_id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Milestone}/project/${pro_id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Milestone:", error.message);
      throw error;
    }
  },

  getDropdownValues: async (field) => {
    try {
      const response = await axios.get(`${ENDPOINT.Milestone}/dropdown/${field}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching dropdown values:", error.message);
      throw error;
    }
  },

  getLastMilestone: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Milestone}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Milestone:", error.message);
      throw error;
    }
  },

  getMilestoneById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Milestone}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Milestone:", error.message);
      throw error;
    }
  },

  createMilestone: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Milestone, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating Milestone:", error.message);
      throw error;
    }
  },

  updateMilestone: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Milestone}/${id}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating Milestone:", error.message);
      throw error;
    }
  },

  deleteMilestone: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Milestone}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting Milestone:", error.message);
      throw error;
    }
  },
};